<template>
  <div class="header">
    <div class="head-bot">
      <div class="flex" v-if="isLogin" >
        <div class="yi-fl head-search">
          <input v-model="keyword" class="yi-fl sec-ipt" type="text" placeholder="发起搜索请求" />
          <a @click.prevent="onSearch" class="yi-fr sec-btn">搜索</a>
        </div>
      </div>
      <div v-if="isLogin" class="yi-fr head-account flex">
        <div @click="onLogin" class="head-me">我的</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderM',
  props: {
    msg: String,
    isLogin: Boolean
  },
  data() {
    return {
      keyword: '',
      account: '',
      hasLogined: false,
    }
  },
  mounted() {
    this.hasLogin();
  },
  methods: {
    hasLogin() {
      const userInfoStr = window.localStorage.getItem('userInfo');
      const userInfo = userInfoStr && JSON.parse(userInfoStr);
      if (userInfo && userInfo.account) {
        this.account = userInfo.account;
        this.hasLogined = true;
      }
    },
    onSearch() {
      console.log('search ... ', this.keyword)
    },
    onLogin() {
      if (this.hasLogined) {
        this.$router.push('/personal-center/m-mine');  
        return;
      }
      this.$router.push('/login');
    },
    gotoHome() {
      this.$router.push('/');
    },
    onPersonalCenter() {
      this.$router.push('/personal-center/profile');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url(./Header.css);
</style>
